export const subPlayer = [
    {
        id:0,
        type:'pitcher',
        no:19, 
        name:'조병현', 
        img: `${process.env.PUBLIC_URL}/images/ssg_019.png`,
        re_text1:'승', record1:7,
        re_text2:'패', record2:3,
        re_text3:'세', record3:17,
        re_text4:'홀', record4:7,
        re_text5:'ERA', record5:1.23,
        re_text6:'WHIP', record6:1.30,
        re_text7:'so', record7:187,
    },
    {
        id:1,
        type:'hitter',
        no:2, 
        name:'박성한', 
        img: `${process.env.PUBLIC_URL}/images/ssg_002.png`,
        re_text1:'게임', record1:87,
        re_text2:'안타', record2:89,
        re_text3:'홈런', record3:22,
        re_text4:'득점', record4:65,
        re_text5:'AVG', record5:3.23,
        re_text6:'OPS', record6:1.00,
        re_text7:'WAR', record7:65.2
    },
    {
        id:2,
        type:'catcher',
        no:20, 
        name:'조형우', 
        img: `${process.env.PUBLIC_URL}/images/ssg_020.png`,
        re_text1:'게임', record1:79,
        re_text2:'안타', record2:55,
        re_text3:'홈런', record3:7,
        re_text4:'득점', record4:44,
        re_text5:'AVG', record5:2.98,
        re_text6:'OPS', record6:0.870,
        re_text7:'WAR', record7:13.2
    }
]